export default "__VITE_ASSET__B7nB6YJU__"